export default __webpack_public_path__ + "static/media/i-ocupacoes.2f1064ca.png";